import { ALLOW_STRING, DATA, ENTITY, KEY, NUMBER, OPTIONAL_KEY, TIMESTAMP, type ValidatorType } from "shelving";

export const NOTIFICATION_ACTIONS = {
	reply: "Reply",
	reaction: "Reaction",
	mention: "Mention",
	follow: "Follow",
	followRequest: "Follow requested",
	followApprove: "Follow request approved",
	groupInvite: "Group invite",
	groupPending: "Group member is pending",
	groupApprove: "Group join request approved",
	challengeProgress: "Challenge progress",
	challengeComplete: "Challenge ccomplete",
};
export type NotificationAction = keyof typeof NOTIFICATION_ACTIONS;

export const NOTIFICATION_SCHEMA = DATA({
	/** Who the notification is for. */
	uid: KEY,
	/** Date it happened. */
	date: TIMESTAMP,
	/** Who caused the notification, i.e. the person who replied/reacted/mentioned to the target. */
	who: OPTIONAL_KEY,
	/** What happened to the target entity, e.g. "reply" or "mention" */
	action: ALLOW_STRING(NOTIFICATION_ACTIONS),
	/** Target entity that was affected, e.g. `challenge:abc123` */
	target: ENTITY,
	/** Count of notifications of this type for `...and 12 others` etc. */
	count: NUMBER,
});
export type NotificationData = ValidatorType<typeof NOTIFICATION_SCHEMA>;
